// 3rd Party
import Analytics from 'analytics-opencare';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Component
import {
  FlexRow,
  H1,
  MarketingButton,
  P,
} from 'common/styles/oc-styled-components';

// Other
import { resetMatches, updatePatient } from 'connect/actions';
import { selectDataMatchId, selectDataUser } from 'connect/selectors';
import { useAnalyticsService } from 'services/AnalyticsService';
import { useRedirectionService } from 'services/RedirectionService';

import { PARTNER_PATH } from '../../../../../containers/App/Routes';
import { usePartnerStorage } from '../../../../partner/storage/Storage';
import { selectAppointmentRequestedId } from '../../../connect/selectors';

import { CheckCircleIcon, IconContainer } from './styled-components';

const analytics = new Analytics();

const RedirectionStep = ({ state }) => {
  const storage = usePartnerStorage();
  const dispatch = useDispatch();

  const analyticsService = useAnalyticsService();
  const redirectionService = useRedirectionService();

  const [isInitializing, setIsInitializing] = useState(true);
  const [enableRedirect, setEnableRedirect] = useState(false);
  const user = useSelector(selectDataUser);
  const matchId = useSelector(selectDataMatchId);
  const appointmentId = useSelector(selectAppointmentRequestedId);

  useEffect(() => {
    setIsInitializing(state.isLoading);
  }, [state]);

  useEffect(() => {
    if (!isInitializing) {
      analytics.trackPageView({
        pageType: analytics.pageTypes.FORM,
        pageName: 'partner_form-booking-completed',
        name: 'form-booking',
        section: 'completed',
        userId: user.id,
        partnerId: user.partner.id,
        patientId: state.id,
        ...analyticsService.analyticsData,
      });

      analytics.waitForQueue().then(() => {
        dispatch(resetMatches());
        dispatch(updatePatient(null));
        storage.clear();

        setEnableRedirect(true);
      });
    }
  }, [isInitializing]);

  const handleRedirect = () => {
    if (storage.isEmpty() && matchId === null) {
      redirectionService.redirect({
        url: PARTNER_PATH,
        reason: 'redirection-step-empty-storage',
      });
    }
  };

  return (
    <div>
      <IconContainer>
        <CheckCircleIcon type="CheckCircle" theme="filled" />
      </IconContainer>
      <H1 data-testid="patientStepHeading" fontSize="20px" textAlign="center">
        You've successfully requested a new appointment!
      </H1>
      <P textAlign="center" fontSize="16px">
        Appointment ID: {appointmentId}
      </P>
      <FlexRow justify="center" align="center" margin="20px 0 0 auto">
        <MarketingButton
          type="primary"
          shape="round"
          size="large"
          block
          maxwidth="335px"
          loading={isInitializing}
          disabled={!enableRedirect}
          data-testid="insuranceSubmitButton"
          htmlType="submit"
          onClick={handleRedirect}
        >
          Start New Search
        </MarketingButton>
      </FlexRow>
    </div>
  );
};

RedirectionStep.propTypes = {
  state: PropTypes.object,
};

export default RedirectionStep;
